import { render, staticRenderFns } from "./TextMenu.vue?vue&type=template&id=4a116144"
import script from "./TextMenu.vue?vue&type=script&lang=js"
export * from "./TextMenu.vue?vue&type=script&lang=js"
import style0 from "./TextMenu.vue?vue&type=style&index=0&id=4a116144&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports